<list-view *ngIf="listeOrganigramme" [liste]="listeOrganigramme" [hover]="false"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>